import type { GameReviewFrame, GameReviewRecord, StoneColor } from '@wx-weiqi/contracts';
import { formatDuration } from './clock-projection';

/** Format the timing-journal projection instead of summing only surviving moves. */
export function formatReviewFrameRemainingTime(
  frame: GameReviewFrame | undefined,
  color: StoneColor,
  record: GameReviewRecord | undefined,
): string {
  if (record?.timingRuleCode === 'NONE_V1') return '不限时';
  const clock = color === 'BLACK' ? frame?.clock?.black : frame?.clock?.white;
  if (clock === undefined || clock === null) return '用时未知';
  if (clock.remainingMs > 0 || record?.byoyomi == null) return formatDuration(clock.remainingMs);
  if (clock.byoyomiPeriodsRemaining === null) return '用时未知';
  if (clock.byoyomiPeriodsRemaining === 0) return '超时';
  // A review frame represents the position after a move, when its partial period resets.
  return `读秒 · ${Math.ceil(record.byoyomi.periodTimeMs / 1_000)}秒 · ${clock.byoyomiPeriodsRemaining}次`;
}
